import { render, staticRenderFns } from "./DashBoardEmployeeComponent.vue?vue&type=template&id=840b1318&scoped=true&"
import script from "./DashBoardEmployeeComponent.vue?vue&type=script&lang=js&"
export * from "./DashBoardEmployeeComponent.vue?vue&type=script&lang=js&"
import style0 from "./DashBoardEmployeeComponent.vue?vue&type=style&index=0&id=840b1318&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "840b1318",
  null
  
)

export default component.exports